
import Vue from 'vue';
import firebase, { db } from '@/plugins/firebase';
import {
  Collection,
  ITimelineEvent,
  ITranscriptionHistory,
  Project,
} from '@/types';
import { Prop, Component } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Auth from '@/store/modules/auth';
import Dialog from '@/store/modules/dialog';
import LikeButton from '../atoms/LikeButton.vue';
import LikeCount from '../atoms/LikeCount.vue';
import UserName from '../atoms/UserName.vue';
import { getCollectionData } from '@/utils/database';

@Component({
  filters: {
    cut(text: string, size: number) {
      return text.substring(0, size);
    },
  },
  components: { LikeButton, LikeCount, UserName },
})
export default class TranscriptionEvent extends Vue {
  @Prop(Object) event!: ITimelineEvent;
  user = { photoURL: 'hoge' };
  entry: any = { likes: {} };
  history: ITranscriptionHistory = <ITranscriptionHistory>{ likers: {} };
  project: Project | null = null;
  collection: Collection | null = null;
  authModule = getModule(Auth, this.$store);
  dialogModule = getModule(Dialog, this.$store);

  get currentUser() {
    return this.authModule.user;
  }

  get isILiked(): boolean {
    const uid = this.authModule.currentUserUid;
    if (!uid) return false;
    if (!this.event.likes) return false;
    return this.event.likes[uid];
  }

  get likeCount(): number {
    if (!this.event.likes) return 0;
    let count = 0;
    Object.values(this.event.likes).forEach((value) => {
      if (value) count++;
    });
    return count;
  }

  get likerUids() {
    return Object.entries(this.event.likes)
      .filter((pair) => pair[1])
      .map((pair) => pair[0]);
  }

  toggleLike(uid: string, value: boolean) {
    //console.log(value);
    if (!this.authModule.user) return;
    this.$set(this.history.likers, uid, value);
    const update = {};
    update[`likers.${uid}`] = value;
    db.collection('transcriptions')
      .doc(this.history.transcriptionId)
      .collection('history')
      .doc(this.event.historyId)
      .update(update);
  }

  async created() {
    this.user = await this.$db.getUserData(this.event.data.uid);
    this.entry = await this.$db.getEntryData(this.event.data.entryId);
    this.collection = await this.$db.getCollectionData(this.entry.collectionId);
    this.project = await this.$db.getProjectData(this.entry.projectId);
    const historyId = this.event.historyId;
    const transcriptionId = this.event.data.transcriptionId;
    this.history = await this.$db.getHistoryData(transcriptionId, historyId);
  }
}
